import {Component, Object3D, property, Type} from '@wonderlandengine/api';

import {vec3} from 'gl-matrix';
import {storageSpace13} from './globals.js';

export class Teleport extends Component {
    static TypeName = 'teleport';

    @property.object({required: true})
    camRoot!: Object3D;
    @property.object({required: true})
    cam!: Object3D;
    @property.object({required: true})
    eyeLeft!: Object3D;
    @property.object({required: true})
    eyeRight!: Object3D;

    private _tempVec: Float32Array;
    private _tempVec0: Float32Array;

    start() {
        this._tempVec = new Float32Array(3);
        this._tempVec0 = new Float32Array(3);

        storageSpace13.gameState.changeOnProperty('playerPosition').add((pos) => {
            this._teleportPlayer(pos);
        });
        storageSpace13.gameState.changeOnProperty('playerRotation').add((rotation) => {
            this._rotatePlayer(rotation);
        });
    }

    _teleportPlayer(newPosition) {
        const p = this._tempVec;
        const p1 = this._tempVec0;

        if (storageSpace13.gameState.isInVR) {
            this.eyeLeft.getTranslationWorld(p);
            this.eyeRight.getTranslationWorld(p1);

            vec3.add(p, p, p1);
            vec3.scale(p, p, 0.5);
        } else {
            this.cam.getTranslationWorld(p);
        }

        this.camRoot.getTranslationWorld(p1);
        vec3.sub(p, p1, p);
        p[0] += newPosition[0];
        p[1] = newPosition[1];
        p[2] += newPosition[2];
        this.camRoot.setTranslationWorld(p);
    }

    _rotatePlayer(rotationToAdd) {
        this.camRoot.resetRotation();
        this.camRoot.rotateAxisAngleDeg([0, 1, 0], rotationToAdd);

        // const p = this._tempVec;
        // const p1 = this._tempVec0;

        // if(StorageSpace13.gameState.isInVR) {
        //     this.eyeLeft.getTranslationWorld(p);
        //     this.eyeRight.getTranslationWorld(p1);

        //     vec3.add(p, p, p1);
        //     vec3.scale(p, p, 0.5);
        // } else {
        //     this.cam.getTranslationWorld(p);
        // }

        // this.camRoot.getTranslationWorld(p1);
        // vec3.sub(p, p1, p);
        // p[0] += newPosition[0];
        // p[1] = newPosition[1];
        // p[2] += newPosition[2];
        // this.camRoot.setTranslationWorld(p);
    }
}
